import React, { ComponentProps, useRef } from 'react';
import { Grid, Box } from '@stitch-fix/mode-react';
import {
  CloudinaryImageWrapper,
  type CloudinaryImageFields,
} from '../CloudinaryImageWrapper';
import { Header } from '../Header';
import styles from './styles.module.scss';

export interface LogoGridProps {
  logoHeader?: ComponentProps<typeof Header>;
  logos: CloudinaryImageFields[];
  columnCount?: number | null;
}

export const LogoGrid = ({ logos, logoHeader, columnCount }: LogoGridProps) => {
  const ref = useRef(null);

  return (
    <Box>
      {logoHeader && <Header {...logoHeader} />}
      <Box className={styles.logoGridContainer} ref={ref}>
        <Grid columns={columnCount ?? 8} spacing="wide" mx="auto">
          {logos.map(logo => (
            <Box className={styles.logoWrapper} key={logo.src}>
              <CloudinaryImageWrapper
                alt={logo.alt}
                aspectRatio={logo.aspectRatio}
                lazy
                src={logo.src}
                sources={{ sm: 100, lg: 120 }}
                cloudinaryAsset={logo.cloudinaryAsset}
                maxContainerWidth={1128}
                sizes={[
                  { minWidth: 0, staticWidth: 100 },
                  { minWidth: 900, staticWidth: 120 },
                ]}
                imageProps={{ loading: 'lazy' }}
              />
            </Box>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};
